import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createSelector } from 'reselect';
import { getOrganizationsList, makeGetOrganization } from 'selectors/organizations';
import { getFormattedRouterLocationSearch, getFormattedSearchParams } from 'selectors/router';
import { getFullPathname } from 'selectors/pathname';
import { CheckboxFilters } from 'constants/filters';

var getProducts = function getProducts(state) {
  return state.products;
};

var getSortPositionMaxToMin = function getSortPositionMaxToMin(a, b) {
  return b - a;
};

var getSortPositionMinToMax = function getSortPositionMinToMax(a, b) {
  return a - b;
};

var getOrganization = makeGetOrganization();
export var getCurrentProducts = createSelector(getProducts, getFullPathname, getFormattedSearchParams, function (state, props) {
  return props.params;
}, function (products, path, _ref, _ref2) {
  var type = _ref.type;
  var page = _ref2.page;

  if (type && !page) {
    var _products$path, _products$path$entiti;

    var newProducts = (_products$path = products[path]) == null ? void 0 : (_products$path$entiti = _products$path.entities) == null ? void 0 : _products$path$entiti.filter(function (el) {
      return el.productClientType.includes(type[0]);
    });
    var newIds = newProducts == null ? void 0 : newProducts.map(function (el) {
      return el.id;
    });
    return _objectSpread(_objectSpread({}, products[path]), {}, {
      entities: newProducts,
      ids: newIds
    }) || {};
  }

  return products[path] || {};
});
export var getProductsIsFetching = createSelector(getCurrentProducts, function (products) {
  return products == null ? void 0 : products.isFetching;
});
export var getProductsIsLoaded = createSelector(getCurrentProducts, function (products) {
  return products == null ? void 0 : products.isLoaded;
});
export var getProductsIsRequestFailed = createSelector(getCurrentProducts, function (products) {
  return products == null ? void 0 : products.isRequestFailed;
});
export var getProductsIds = createSelector(getCurrentProducts, function (products) {
  return products.ids || [];
});
export var getProductsEntities = createSelector(getCurrentProducts, function (products) {
  return products.entities || [];
});
export var getProductsItems = createSelector(getProductsIds, getProductsEntities, function (ids, entities) {
  var productsItems = ids == null ? void 0 : ids.flat().reduce(function (result, id) {
    var indexOfEntities = entities == null ? void 0 : entities.map(function (el) {
      return el.id;
    }).indexOf(id);

    if (indexOfEntities !== -1) {
      result.push(entities[indexOfEntities]);
    }

    return result;
  }, []);
  return productsItems;
});
export var getCompanyWithProducts = createSelector(getProductsItems, getOrganization, function (products, organization) {
  return _objectSpread(_objectSpread({}, organization.data), {}, {
    products: products
  });
});

var getFilterProductsBySearchParams = function getFilterProductsBySearchParams(routerLocationSearch, productItems) {
  var _Object$values$filter;

  if (!((_Object$values$filter = Object.values(routerLocationSearch).filter(function (el) {
    return el == null ? void 0 : el.length;
  })) != null && _Object$values$filter.length)) {
    return productItems;
  }

  var formatedFilters = Object.keys(routerLocationSearch).reduce(function (res, cur) {
    var _routerLocationSearch;

    return [].concat(_toConsumableArray(res), _toConsumableArray((_routerLocationSearch = routerLocationSearch[cur]) == null ? void 0 : _routerLocationSearch.map(function (el) {
      return _defineProperty({}, cur, el);
    })));
  }, []);
  var filterByCheckboxes = formatedFilters.reduce(function (res, cur) {
    var _CheckboxFilters$key$;

    var key = Object.keys(cur)[0];
    var value = cur[key];
    return (_CheckboxFilters$key$ = CheckboxFilters[key][value]) == null ? void 0 : _CheckboxFilters$key$.getFiltred(res);
  }, productItems);
  return filterByCheckboxes;
};

var getProductsGroupByOrganizations = function getProductsGroupByOrganizations(products) {
  return products.reduce(function (res, product) {
    if (!product.vendorId) return res;
    res[product.vendorId] = res[product.vendorId] ? [].concat(_toConsumableArray(res[product.vendorId]), [product]) : [product];
    return res;
  }, {});
};

var getOrganizationById = function getOrganizationById(id, organizations) {
  return organizations.find(function (org) {
    return org.id === id;
  });
};

var getOrganizationsWithProducts = function getOrganizationsWithProducts(productsByOrganizations, organizations) {
  return Object.keys(productsByOrganizations).reduce(function (res, organizationId) {
    var organizationById = getOrganizationById(+organizationId, organizations);

    if (!organizationById) {
      return res;
    }

    var organizationWithProducts = _objectSpread(_objectSpread({}, organizationById), {}, {
      products: productsByOrganizations[organizationId]
    });

    return [].concat(_toConsumableArray(res), [organizationWithProducts]);
  }, []);
};

var isArrHasUniqueValue = function isArrHasUniqueValue(arr) {
  return new Set(arr).size > 1;
};

var getDefaultSortProducts = function getDefaultSortProducts(currentCards, organization) {
  if (isArrHasUniqueValue(currentCards == null ? void 0 : currentCards.map(function (card) {
    return card.trackingUrl;
  }))) {
    return _objectSpread(_objectSpread({}, organization), {}, {
      products: currentCards == null ? void 0 : currentCards.sort(function (a, b) {
        return getSortPositionMinToMax(a.trackingUrl, b.trackingUrl);
      })
    });
  }

  if (isArrHasUniqueValue(currentCards == null ? void 0 : currentCards.map(function (card) {
    return card.monthlyFee;
  }))) {
    return _objectSpread(_objectSpread({}, organization), {}, {
      products: currentCards == null ? void 0 : currentCards.sort(function (a, b) {
        return getSortPositionMinToMax(a.monthlyFee, b.monthlyFee);
      })
    });
  }

  if (isArrHasUniqueValue(currentCards == null ? void 0 : currentCards.map(function (card) {
    return card.firstAccountOpeningFee;
  }))) {
    return _objectSpread(_objectSpread({}, organization), {}, {
      products: currentCards == null ? void 0 : currentCards.sort(function (a, b) {
        return getSortPositionMinToMax(a.firstAccountOpeningFee, b.firstAccountOpeningFee);
      })
    });
  }

  return _objectSpread(_objectSpread({}, organization), {}, {
    products: currentCards == null ? void 0 : currentCards.sort(function (a, b) {
      return getSortPositionMaxToMin(a.id, b.id);
    })
  });
};

var getDefaultSortOrganizationsByProducts = function getDefaultSortOrganizationsByProducts(data) {
  var getCurrentProduct = function getCurrentProduct(org) {
    var _org$products;

    return org == null ? void 0 : (_org$products = org.products) == null ? void 0 : _org$products[0];
  };

  return data.sort(function (a, b) {
    var aProduct = getCurrentProduct(a);
    var bProduct = getCurrentProduct(b);

    if ((aProduct == null ? void 0 : aProduct.monthlyFee) !== (bProduct == null ? void 0 : bProduct.monthlyFee)) {
      return getSortPositionMinToMax(aProduct.monthlyFee, bProduct.monthlyFee);
    }

    return getSortPositionMinToMax(aProduct.paymentAbsolute, bProduct.paymentAbsolute);
  });
};

var getSortedOrganizationsAndProducts = function getSortedOrganizationsAndProducts(productsByOrganization) {
  return getDefaultSortOrganizationsByProducts(productsByOrganization.reduce(function (res, cur) {
    var organizationWithSortedProducts = getDefaultSortProducts(cur.products, cur);
    return [].concat(_toConsumableArray(res), [organizationWithSortedProducts]);
  }, [])).reduce(function (res, cur) {
    if ((cur == null ? void 0 : cur.rkoCommercialOrderMinfin) !== 0) {
      var prev = res.slice(0, cur.rkoCommercialOrderMinfin - 1);
      var next = res.slice(cur.rkoCommercialOrderMinfin - 1);
      return [].concat(_toConsumableArray(prev), [cur], _toConsumableArray(next));
    }

    return [].concat(_toConsumableArray(res), [cur]);
  }, []);
};

export var getCompaniesWithProducts = createSelector(getProductsItems, getOrganizationsList, getFormattedRouterLocationSearch, function (products, organizations, routerLocationSearch) {
  var filtredProducts = getFilterProductsBySearchParams(routerLocationSearch, products);
  var productsGroupedByOrganizations = getProductsGroupByOrganizations(filtredProducts);
  var organizationsWithProducts = getOrganizationsWithProducts(productsGroupedByOrganizations, organizations);
  var sortedOrganizationsWithProducts = getSortedOrganizationsAndProducts(organizationsWithProducts, routerLocationSearch);
  return sortedOrganizationsWithProducts;
});